import {Component} from '@angular/core';
import {BlockBaseComponent} from "../block-base/block-base.component";
import {StoreSelectorsService} from "../../../../services";
import {MatDialog} from "@angular/material/dialog";
import {TranslocoService} from "@ngneat/transloco";
import {DialogCodeComponent} from "../../../../components/dialog-code/dialog-code.component";
import {DialogCorsComponent} from "../../../../components/dialog-cors/dialog-cors.component";

@Component({
    selector: 'app-scene-block-html',
    templateUrl: './block-html.component.html',
    styleUrls: ['./block-html.component.scss']
})
export class BlockHtmlComponent extends BlockBaseComponent {
    selectedShipTo = '';
    sampleSites = [
        {link: 'https://www.digitalsignage.com', name: 'DigitalSignage.com'},
        {link: 'https://www.usgs.gov', name: 'U.S. Geological Survey'},
        {link: 'https://www.nhl.com', name: 'NHL'},
        {link: 'https://www.nfl.com', name: 'NFL'},
        {link: 'https://www.airport-la.com', name: 'Airport LA'},
        {link: 'https://www.los-angeles-airport.com', name: 'Los Angeles Airport'},
        {link: 'https://www.usnews.com', name: 'US News'},
        {link: 'https://en.wikipedia.org/wiki/Main_Page', name: 'Wikipedia'},
        {link: 'https://abcnews.go.com', name: 'ABC News'},
        {link: 'https://www.cbsnews.com', name: 'CBS News'},
        {link: 'https://apnews.com', name: 'AP News'},
        {link: 'https://www.npr.org', name: 'NPR.org'},
        {link: 'https://www.axios.com', name: 'AXIOS'},
        {link: 'https://www.foxnews.com', name: 'Fox News'},
        {link: 'https://www.sciencenews.org', name: 'ScienceNews.org'},
        {link: 'https://www.socialmediatoday.com', name: 'SocialMediaToday'},
        {link: 'https://bleacherreport.com', name: 'Bleacher Report'},
        {link: 'https://www.wsj.com', name: 'The Wall Street Journal'},
        {link: 'https://www.pewresearch.org', name: 'Pew Research Center'},
        {link: 'https://www.ft.com', name: 'Financial Times'},
        {link: 'https://www.medscape.com', name: 'Medscape'},
        {link: 'https://www.medicalnewstoday.com', name: 'Medical News Today'},
        {link: 'https://www.goodnewsnetwork.org', name: 'Good News Network'},
        {link: 'https://www.factcheck.org', name: 'FactCheck.org'},
        {link: 'https://www.msnbc.com', name: 'MSNBC'},
        {link: 'https://www.edweek.org', name: 'Education Week'},
        {link: 'https://globalnews.ca', name: 'Global News'},
        {link: 'https://www.pbs.org/newshour', name: 'PBS News Hour'},
        {link: 'https://www.independent.co.uk/asia', name: 'Independent Asia Edition'},
        {link: 'https://www.euronews.com', name: 'Euro News'},
        {link: 'https://www.dailynews.com', name: 'Los Angeles Daily News'},
        {link: 'https://www.ap.org/en/#', name: 'Ap.org'},
        {link: 'https://apnews.com', name: 'Ap News'},
        {link: 'https://www.houstonchronicle.com', name: 'houston Chronicle'},
        {link: 'https://www.lotteryusa.com', name: 'Lottery USA'},
        {link: 'https://www.onlineunitedstatescasinos.com', name: 'Online United States Casinos'},
        {link: 'https://www.fifa.com', name: 'FIFA'},
        {link: 'https://www.gamingtoday.com', name: 'Gaming Today - Betting News'},
        {link: 'https://www.racefans.net', name: 'RaceFans'},
        {link: 'https://www.thecheckeredflag.co.uk', name: 'The Checkered Flag'},
        {link: 'https://radar.weather.gov', name: 'NWS Radar'},
        {link: 'https://www.weatherbug.com/maps', name: 'WeatherBug Maps'},
        {link: 'https://www.medicaleconomics.com', name: 'Medical Economics'},
        {link: 'https://www.aam-us.org', name: 'American Alliance of Museums'},
        {link: 'https://www.webmd.com', name: 'WebMD'},
        {link: 'https://www.daily-tribune.com', name: 'Daily Tribute'},
        {link: 'https://www.reuters.com', name: 'Reuters'},
        {link: 'https://www.sfgate.com', name: 'San Francisco Gate'},
        {link: 'https://www.chicagotribune.com', name: 'Chicago Tribune'},
        {link: 'https://www.bu.edu', name: 'Boston University'},
        {link: 'https://www.spacex.com', name: 'Space X'},
        {link: 'https://www.nationalgeographic.com', name: 'National Geographic'},
        {link: 'https://www.ft.com', name: 'Financial Times'},
        {link: 'https://dashboardpack.com/live-demo-preview/?livedemo=353784', name: 'Dashboard sample 1'},
        {link: 'https://dashboardpack.com/live-demo-preview/?livedemo=360380', name: 'Dashboard sample 2'},
        {link: 'https://www.akveo.com/ngx-admin/pages/dashboard?theme=material-dark', name: 'Dashboard sample 3'},
        {link: 'https://demos.creative-tim.com/vision-ui-dashboard-pro-chakra/#/admin/dashboard/default', name: 'Dashboard sample 4'},
    ];

    constructor(private translocoService: TranslocoService, public override storeSelector: StoreSelectorsService, public override dialog: MatDialog) {
        super(storeSelector, dialog);
    }

    override submit(formValues) {
        return super.submit(formValues);
    }

    override componentInit() {
        super.componentInit();
    }

    override componentStoreUpdates() {
        super.componentStoreUpdates();
    }

    openCors() {
        this.dialog.open(DialogCorsComponent, {
            width: '400px'
        });
    }

    onSelectedShipTo(e) {
        this.setFormValue('src', e.value.link);
        this.dispatchSceneItemChanges({
            sceneId: this.sceneId,
            sceneItemId: this.sceneItem.$.id,
            values: [{
                key: 'src',
                value: e.value.link,
                storePath: 'Data[0].HTML[0].$'
            }]
        });
    }

    override initRegisterDynamic() {
        this.uiConfigInit = [
            {
                type: "input",
                value: '',
                label: this.translocoService.translate('general.source', {}, this.translocoService.getActiveLang()),
                inputType: "text",
                restrictChar: "basic0",
                name: "src",
                storePath: 'Data[0].HTML[0].$.src'
            },
            {
                type: "checkbox",
                value: '1',
                label: this.translocoService.translate('general.staticTexture', {}, this.translocoService.getActiveLang()),
                name: "staticTexture",
                storePath: 'Data[0].HTML[0].$.staticTexture'
            },
            {
                type: "checkbox",
                value: '1',
                label: this.translocoService.translate('general.showScrolls', {}, this.translocoService.getActiveLang()),
                name: "showScrolls",
                storePath: 'Data[0].HTML[0].$.showScrolls'
            },
            {
                type: "checkbox",
                value: '1',
                label: this.translocoService.translate('general.useProxy', {}, this.translocoService.getActiveLang()),
                name: "useProxy",
                storePath: 'Data[0].HTML[0].$.useProxy'
            },
            // {
            //     type: "input",
            //     value: '',
            //     label: this.translocoService.translate('general.config', {}, this.translocoService.getActiveLang()),
            //     inputType: "text",
            //     name: "config",
            //     storePath: 'Data[0].HTML[0].$.config'
            // },
            // {
            //     type: "checkbox",
            //     value: '1',
            //     label: this.translocoService.translate('general.gpu', {}, this.translocoService.getActiveLang()),
            //     name: "gpu",
            //     storePath: '$.gpu'
            // }
        ];
    }
}

